module.exports = __webpack_public_path__ + "img/like.3c39e5ae.svg";